import { Box, CircularProgress } from '@mui/material'

import { filePreviewBox } from 'elements/FileUpload/common/styles'
import { concatToSXProp } from 'utils/style'

export default function FilePreviewLoading(): JSX.Element {
  return (
    <Box
      sx={concatToSXProp(filePreviewBox, {
        color: 'text.secondary',
      })}
    >
      <CircularProgress size={30} color="inherit" />
    </Box>
  )
}
